import { aiApi } from '@/api/client'

// 解卦函数 - 已迁移到后端处理
export const interpretHexagram = async (params) => {
  try {
    const response = await aiApi.post('/api/iching/interpret', params)
    return response
  } catch (error) {
    console.error('周易解卦失败:', error)
    throw new Error('解卦失败，请稍后重试')
  }
}
